import { render, staticRenderFns } from "./selSubject.vue?vue&type=template&id=9ae8c82a&scoped=true&"
import script from "./selSubject.vue?vue&type=script&lang=js&"
export * from "./selSubject.vue?vue&type=script&lang=js&"
import style0 from "./selSubject.vue?vue&type=style&index=0&id=9ae8c82a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae8c82a",
  null
  
)

export default component.exports